"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NoteIcon = (0, _createIconComponent["default"])({
  content: 'NOTE',
  height: 24,
  width: 24
});
NoteIcon.displayName = 'NoteIcon';
var _default = NoteIcon;
exports["default"] = _default;